interface OdometerRow {
  odometer?: number | null;
  /** Previous trip's end reading in km (see `withOdometerStarts`). */
  odometerStartKm?: number | null;
}

/**
 * Trip.odometer is the end reading in meters. Returns km, or null without a reading. The start is
 * the previous trip's end reading, as on the logbook pages; without a predecessor it stays blank
 * (GPS distances are never used for the odometer).
 */
export function getTripOdometerKm(row: OdometerRow, variant: "start" | "end"): number | null {
  const odometerMeters = row.odometer;
  if (!odometerMeters) return null;
  if (variant === "end") return odometerMeters / 1000;
  return row.odometerStartKm ?? null;
}
